export interface CountryDial {
  iso: string;
  name: string;
  dial: string;
}

// Regionální indikátorové symboly z ISO kódu → vlajková emoji (spolehlivější
// než ukládat emoji přímo). Např. "CZ" → 🇨🇿.
export function isoToFlag(iso: string): string {
  return iso
    .toUpperCase()
    .replace(/[^A-Z]/g, '')
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

// Nejčastější předvolby (zobrazí se nahoře).
export const COMMON_DIAL_ISO = ['CZ', 'SK'];

export const COUNTRY_DIAL_CODES: CountryDial[] = [
  { iso: 'CZ', name: 'Česko', dial: '+420' },
  { iso: 'SK', name: 'Slovensko', dial: '+421' },
  { iso: 'AF', name: 'Afghánistán', dial: '+93' },
  { iso: 'AL', name: 'Albánie', dial: '+355' },
  { iso: 'DZ', name: 'Alžírsko', dial: '+213' },
  { iso: 'AD', name: 'Andorra', dial: '+376' },
  { iso: 'AO', name: 'Angola', dial: '+244' },
  { iso: 'AG', name: 'Antigua a Barbuda', dial: '+1268' },
  { iso: 'AR', name: 'Argentina', dial: '+54' },
  { iso: 'AM', name: 'Arménie', dial: '+374' },
  { iso: 'AU', name: 'Austrálie', dial: '+61' },
  { iso: 'AT', name: 'Rakousko', dial: '+43' },
  { iso: 'AZ', name: 'Ázerbájdžán', dial: '+994' },
  { iso: 'BS', name: 'Bahamy', dial: '+1242' },
  { iso: 'BH', name: 'Bahrajn', dial: '+973' },
  { iso: 'BD', name: 'Bangladéš', dial: '+880' },
  { iso: 'BB', name: 'Barbados', dial: '+1246' },
  { iso: 'BY', name: 'Bělorusko', dial: '+375' },
  { iso: 'BE', name: 'Belgie', dial: '+32' },
  { iso: 'BZ', name: 'Belize', dial: '+501' },
  { iso: 'BJ', name: 'Benin', dial: '+229' },
  { iso: 'BT', name: 'Bhútán', dial: '+975' },
  { iso: 'BO', name: 'Bolívie', dial: '+591' },
  { iso: 'BA', name: 'Bosna a Hercegovina', dial: '+387' },
  { iso: 'BW', name: 'Botswana', dial: '+267' },
  { iso: 'BR', name: 'Brazílie', dial: '+55' },
  { iso: 'BN', name: 'Brunej', dial: '+673' },
  { iso: 'BG', name: 'Bulharsko', dial: '+359' },
  { iso: 'BF', name: 'Burkina Faso', dial: '+226' },
  { iso: 'BI', name: 'Burundi', dial: '+257' },
  { iso: 'KH', name: 'Kambodža', dial: '+855' },
  { iso: 'CM', name: 'Kamerun', dial: '+237' },
  { iso: 'CA', name: 'Kanada', dial: '+1' },
  { iso: 'CV', name: 'Kapverdy', dial: '+238' },
  { iso: 'CF', name: 'Středoafrická republika', dial: '+236' },
  { iso: 'TD', name: 'Čad', dial: '+235' },
  { iso: 'CL', name: 'Chile', dial: '+56' },
  { iso: 'CN', name: 'Čína', dial: '+86' },
  { iso: 'CO', name: 'Kolumbie', dial: '+57' },
  { iso: 'KM', name: 'Komory', dial: '+269' },
  { iso: 'CG', name: 'Kongo', dial: '+242' },
  { iso: 'CD', name: 'Kongo (DR)', dial: '+243' },
  { iso: 'CR', name: 'Kostarika', dial: '+506' },
  { iso: 'CI', name: 'Pobřeží slonoviny', dial: '+225' },
  { iso: 'HR', name: 'Chorvatsko', dial: '+385' },
  { iso: 'CU', name: 'Kuba', dial: '+53' },
  { iso: 'CY', name: 'Kypr', dial: '+357' },
  { iso: 'DK', name: 'Dánsko', dial: '+45' },
  { iso: 'DJ', name: 'Džibutsko', dial: '+253' },
  { iso: 'DM', name: 'Dominika', dial: '+1767' },
  { iso: 'DO', name: 'Dominikánská republika', dial: '+1809' },
  { iso: 'EC', name: 'Ekvádor', dial: '+593' },
  { iso: 'EG', name: 'Egypt', dial: '+20' },
  { iso: 'SV', name: 'Salvador', dial: '+503' },
  { iso: 'GQ', name: 'Rovníková Guinea', dial: '+240' },
  { iso: 'ER', name: 'Eritrea', dial: '+291' },
  { iso: 'EE', name: 'Estonsko', dial: '+372' },
  { iso: 'SZ', name: 'Eswatini', dial: '+268' },
  { iso: 'ET', name: 'Etiopie', dial: '+251' },
  { iso: 'FJ', name: 'Fidži', dial: '+679' },
  { iso: 'FI', name: 'Finsko', dial: '+358' },
  { iso: 'FR', name: 'Francie', dial: '+33' },
  { iso: 'GA', name: 'Gabon', dial: '+241' },
  { iso: 'GM', name: 'Gambie', dial: '+220' },
  { iso: 'GE', name: 'Gruzie', dial: '+995' },
  { iso: 'DE', name: 'Německo', dial: '+49' },
  { iso: 'GH', name: 'Ghana', dial: '+233' },
  { iso: 'GR', name: 'Řecko', dial: '+30' },
  { iso: 'GD', name: 'Grenada', dial: '+1473' },
  { iso: 'GT', name: 'Guatemala', dial: '+502' },
  { iso: 'GN', name: 'Guinea', dial: '+224' },
  { iso: 'GW', name: 'Guinea-Bissau', dial: '+245' },
  { iso: 'GY', name: 'Guyana', dial: '+592' },
  { iso: 'HT', name: 'Haiti', dial: '+509' },
  { iso: 'HN', name: 'Honduras', dial: '+504' },
  { iso: 'HK', name: 'Hongkong', dial: '+852' },
  { iso: 'HU', name: 'Maďarsko', dial: '+36' },
  { iso: 'IS', name: 'Island', dial: '+354' },
  { iso: 'IN', name: 'Indie', dial: '+91' },
  { iso: 'ID', name: 'Indonésie', dial: '+62' },
  { iso: 'IR', name: 'Írán', dial: '+98' },
  { iso: 'IQ', name: 'Irák', dial: '+964' },
  { iso: 'IE', name: 'Irsko', dial: '+353' },
  { iso: 'IL', name: 'Izrael', dial: '+972' },
  { iso: 'IT', name: 'Itálie', dial: '+39' },
  { iso: 'JM', name: 'Jamajka', dial: '+1876' },
  { iso: 'JP', name: 'Japonsko', dial: '+81' },
  { iso: 'JO', name: 'Jordánsko', dial: '+962' },
  { iso: 'KZ', name: 'Kazachstán', dial: '+7' },
  { iso: 'KE', name: 'Keňa', dial: '+254' },
  { iso: 'KI', name: 'Kiribati', dial: '+686' },
  { iso: 'KW', name: 'Kuvajt', dial: '+965' },
  { iso: 'KG', name: 'Kyrgyzstán', dial: '+996' },
  { iso: 'LA', name: 'Laos', dial: '+856' },
  { iso: 'LV', name: 'Lotyšsko', dial: '+371' },
  { iso: 'LB', name: 'Libanon', dial: '+961' },
  { iso: 'LS', name: 'Lesotho', dial: '+266' },
  { iso: 'LR', name: 'Libérie', dial: '+231' },
  { iso: 'LY', name: 'Libye', dial: '+218' },
  { iso: 'LI', name: 'Lichtenštejnsko', dial: '+423' },
  { iso: 'LT', name: 'Litva', dial: '+370' },
  { iso: 'LU', name: 'Lucembursko', dial: '+352' },
  { iso: 'MO', name: 'Macao', dial: '+853' },
  { iso: 'MG', name: 'Madagaskar', dial: '+261' },
  { iso: 'MW', name: 'Malawi', dial: '+265' },
  { iso: 'MY', name: 'Malajsie', dial: '+60' },
  { iso: 'MV', name: 'Maledivy', dial: '+960' },
  { iso: 'ML', name: 'Mali', dial: '+223' },
  { iso: 'MT', name: 'Malta', dial: '+356' },
  { iso: 'MH', name: 'Marshallovy ostrovy', dial: '+692' },
  { iso: 'MR', name: 'Mauritánie', dial: '+222' },
  { iso: 'MU', name: 'Mauricius', dial: '+230' },
  { iso: 'MX', name: 'Mexiko', dial: '+52' },
  { iso: 'FM', name: 'Mikronésie', dial: '+691' },
  { iso: 'MD', name: 'Moldavsko', dial: '+373' },
  { iso: 'MC', name: 'Monako', dial: '+377' },
  { iso: 'MN', name: 'Mongolsko', dial: '+976' },
  { iso: 'ME', name: 'Černá Hora', dial: '+382' },
  { iso: 'MA', name: 'Maroko', dial: '+212' },
  { iso: 'MZ', name: 'Mosambik', dial: '+258' },
  { iso: 'MM', name: 'Myanmar', dial: '+95' },
  { iso: 'NA', name: 'Namibie', dial: '+264' },
  { iso: 'NR', name: 'Nauru', dial: '+674' },
  { iso: 'NP', name: 'Nepál', dial: '+977' },
  { iso: 'NL', name: 'Nizozemsko', dial: '+31' },
  { iso: 'NZ', name: 'Nový Zéland', dial: '+64' },
  { iso: 'NI', name: 'Nikaragua', dial: '+505' },
  { iso: 'NE', name: 'Niger', dial: '+227' },
  { iso: 'NG', name: 'Nigérie', dial: '+234' },
  { iso: 'KP', name: 'Severní Korea', dial: '+850' },
  { iso: 'MK', name: 'Severní Makedonie', dial: '+389' },
  { iso: 'NO', name: 'Norsko', dial: '+47' },
  { iso: 'OM', name: 'Omán', dial: '+968' },
  { iso: 'PK', name: 'Pákistán', dial: '+92' },
  { iso: 'PW', name: 'Palau', dial: '+680' },
  { iso: 'PS', name: 'Palestina', dial: '+970' },
  { iso: 'PA', name: 'Panama', dial: '+507' },
  { iso: 'PG', name: 'Papua-Nová Guinea', dial: '+675' },
  { iso: 'PY', name: 'Paraguay', dial: '+595' },
  { iso: 'PE', name: 'Peru', dial: '+51' },
  { iso: 'PH', name: 'Filipíny', dial: '+63' },
  { iso: 'PL', name: 'Polsko', dial: '+48' },
  { iso: 'PT', name: 'Portugalsko', dial: '+351' },
  { iso: 'QA', name: 'Katar', dial: '+974' },
  { iso: 'RO', name: 'Rumunsko', dial: '+40' },
  { iso: 'RU', name: 'Rusko', dial: '+7' },
  { iso: 'RW', name: 'Rwanda', dial: '+250' },
  { iso: 'KN', name: 'Svatý Kryštof a Nevis', dial: '+1869' },
  { iso: 'LC', name: 'Svatá Lucie', dial: '+1758' },
  { iso: 'VC', name: 'Svatý Vincenc a Grenadiny', dial: '+1784' },
  { iso: 'WS', name: 'Samoa', dial: '+685' },
  { iso: 'SM', name: 'San Marino', dial: '+378' },
  { iso: 'ST', name: 'Svatý Tomáš a Princův ostrov', dial: '+239' },
  { iso: 'SA', name: 'Saúdská Arábie', dial: '+966' },
  { iso: 'SN', name: 'Senegal', dial: '+221' },
  { iso: 'RS', name: 'Srbsko', dial: '+381' },
  { iso: 'SC', name: 'Seychely', dial: '+248' },
  { iso: 'SL', name: 'Sierra Leone', dial: '+232' },
  { iso: 'SG', name: 'Singapur', dial: '+65' },
  { iso: 'SI', name: 'Slovinsko', dial: '+386' },
  { iso: 'SB', name: 'Šalomounovy ostrovy', dial: '+677' },
  { iso: 'SO', name: 'Somálsko', dial: '+252' },
  { iso: 'ZA', name: 'Jihoafrická republika', dial: '+27' },
  { iso: 'KR', name: 'Jižní Korea', dial: '+82' },
  { iso: 'SS', name: 'Jižní Súdán', dial: '+211' },
  { iso: 'ES', name: 'Španělsko', dial: '+34' },
  { iso: 'LK', name: 'Srí Lanka', dial: '+94' },
  { iso: 'SD', name: 'Súdán', dial: '+249' },
  { iso: 'SR', name: 'Surinam', dial: '+597' },
  { iso: 'SE', name: 'Švédsko', dial: '+46' },
  { iso: 'CH', name: 'Švýcarsko', dial: '+41' },
  { iso: 'SY', name: 'Sýrie', dial: '+963' },
  { iso: 'TW', name: 'Tchaj-wan', dial: '+886' },
  { iso: 'TJ', name: 'Tádžikistán', dial: '+992' },
  { iso: 'TZ', name: 'Tanzanie', dial: '+255' },
  { iso: 'TH', name: 'Thajsko', dial: '+66' },
  { iso: 'TL', name: 'Východní Timor', dial: '+670' },
  { iso: 'TG', name: 'Togo', dial: '+228' },
  { iso: 'TO', name: 'Tonga', dial: '+676' },
  { iso: 'TT', name: 'Trinidad a Tobago', dial: '+1868' },
  { iso: 'TN', name: 'Tunisko', dial: '+216' },
  { iso: 'TR', name: 'Turecko', dial: '+90' },
  { iso: 'TM', name: 'Turkmenistán', dial: '+993' },
  { iso: 'TV', name: 'Tuvalu', dial: '+688' },
  { iso: 'UG', name: 'Uganda', dial: '+256' },
  { iso: 'UA', name: 'Ukrajina', dial: '+380' },
  { iso: 'AE', name: 'Spojené arabské emiráty', dial: '+971' },
  { iso: 'GB', name: 'Spojené království', dial: '+44' },
  { iso: 'US', name: 'Spojené státy', dial: '+1' },
  { iso: 'UY', name: 'Uruguay', dial: '+598' },
  { iso: 'UZ', name: 'Uzbekistán', dial: '+998' },
  { iso: 'VU', name: 'Vanuatu', dial: '+678' },
  { iso: 'VA', name: 'Vatikán', dial: '+379' },
  { iso: 'VE', name: 'Venezuela', dial: '+58' },
  { iso: 'VN', name: 'Vietnam', dial: '+84' },
  { iso: 'YE', name: 'Jemen', dial: '+967' },
  { iso: 'ZM', name: 'Zambie', dial: '+260' },
  { iso: 'ZW', name: 'Zimbabwe', dial: '+263' },
];
